import "./index.css"
import "./mobile.css"

function SectionBlock(props) {
    return <div className="section-block" onClick={props.addFunction} data-hexcode={props.hexCode}>
    <img className="section-image" src={props.imageSource} alt="Icon for section"></img>
    <h2 className="section-title">{props.title}</h2>
    <p className="section-description">{props.description}</p>    
    </div>;
  }

export default SectionBlock;
